<template>
    <v-row class="mt-n5">
        <v-col cols="auto">
            <tile-search-date
                init-type="WEEK"
                @changed="searchDateChanged"
                @inited="searchDateInited"
                ref="date_range_select"
                :from-day="searchParam.search_start"
                :to-day="searchParam.search_end"
            ></tile-search-date>
        </v-col>
        <v-col cols="auto" class="d-flex align-center pl-2">
            <tile-search-button @click="handleSearch"></tile-search-button>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'TileSearchHeader',
    components: {
        'TileSearchDate': () => import('@/components/stats/tile_search_date.vue'),
        'TileSearchButton': () => import('@/components/common/tile_search_button.vue'),
    },
    props: {
        searchParam: {
            type: Object,
            required: true
        }
    },
    methods: {
        searchDateInited(payload) {
            this.$emit('search-date-inited', payload)
        },
        searchDateChanged(payload) {
            this.$emit('search-date-changed', payload)
        },
        handleSearch() {
            this.$emit('search', 1)
        }
    }
}
</script>